import { lazy } from 'react';
import { CATALOG_PERMISSIONS } from './constants';

const ProductListPage = lazy(() => import('./pages/ProductListPage'));
const FlaggedProductsPage = lazy(() => import('./pages/FlaggedProductsPage'));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage'));

export const catalogRoutes = [
  {
    path: '/catalog',
    element: ProductListPage,
    permission: CATALOG_PERMISSIONS.MODERATE,
    nav: { labelKey: 'nav.catalog', icon: 'ShoppingOutlined', group: 'commerce' },
  },
  {
    path: '/catalog/flagged',
    element: FlaggedProductsPage,
    permission: CATALOG_PERMISSIONS.MODERATE,
    nav: { labelKey: 'nav.catalogFlagged', icon: 'FlagOutlined', group: 'commerce' },
  },
  {
    path: '/catalog/:id',
    element: ProductDetailPage,
    permission: CATALOG_PERMISSIONS.MODERATE,
    nav: null,
  },
];
